<template>

  <div>
  <el-popover class="bootom_right"
              placement="left-end"
              trigger="click">

    <div>
      <div style="text-align: center;font-size: 20px;color: #7c3289;font-weight: bold;
  ">微信客服</div>
      <el-image
              style="width: 200px;"
              :src="require('@/assets/image/qrcode_kefu.png')"
      ></el-image>
      <div  style="text-align: center;font-size: 15px;">扫码咨询</div>
    </div>
    <a href="javaScript:;" slot="reference">
    <el-image style="width: 60px;"
              :src="require('@/assets/image/z9622.png')"
    ></el-image>
    </a>

  </el-popover>
    <a href="javaScript:;">
  <el-image @click="goTop()" :src="require('@/assets/image/z9743.png')" style="width: 40px;"  class="bootom_right_top"></el-image>
    </a>
  </div>

</template>

<script>
import deviceAdapter from '@/mixins/deviceAdapter'
import navigationFixed from '@/mixins/navigationFixed'
import { getMobile } from '@/utils/util'
// import { loginout } from '@/api/official'
export default {
  mixins: [deviceAdapter, navigationFixed],
  props: {
    activeName: {
      type: String,
      default: '1'
    }
  },
  created() {
  },
  data() {
    return {
    };
  },
  methods: {
      goTop(){
          document.getElementById('top').scrollIntoView({ behavior: "smooth" });
      },
    goMeasure(category){
        this.$router.push({ name: "pcMeasurement",query:{
            scene:1,
            category:category
        } })
    }
  },
};
</script>

<style scoped>



  .bootom_right_cp {
    position: fixed;
    display: flex;
    flex-direction: column;
    right: 16px;
    bottom: 170px;
    z-index: 10;
    padding: 3px 3px 0 3px;
  }


  .bootom_right {
    position: fixed;
    display: flex;
    flex-direction: column;
    right: 16px;
    bottom: 90px;
    z-index: 10;
    padding: 3px 3px 0 3px;
  }


  .bootom_right_top {
    position: fixed;
    display: flex;

    flex-direction: column;
    right: 28px;
    bottom: 40px;
    z-index: 10;
  }

</style>